module.exports = __webpack_public_path__ + "static/media/yt-designing.99df31f6.jpeg";